import { removeAllReference } from "../../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../../utils/types/generals"
import { FormatTrackingForm } from "../types"

export const formatTrackingForm: FormatTrackingForm = ({ name, body, items, setFilterData }) => {
    let localeBodyFilterData: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
        const { area, department } = localeBodyFilterData
        const newDepartments = department?.filter((department: any) => area.find((area: any) => area.value == department.areaId))
        let departmentItems: Item[] = []

        area?.forEach((area: any) => {
            const areaId = area.value
            const departmentsFiltereds = items.department.filter((department) => department.areaId == areaId)
            departmentItems.push(...departmentsFiltereds)
        })

        setFilterData((prev) => ({
            ...prev,
            department: newDepartments,
        }))

        localeBodyFilterData = {
            ...localeBodyFilterData,
            department: newDepartments,
        }
        return { body: localeBodyFilterData, department: departmentItems }
    }
    return { body: localeBodyFilterData, department: items.department }
}